import { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  TableHeader,
  TableLoader,
} from "../../components/commons";
import { Toaster, toast } from "react-hot-toast";
import { SearchIcon } from "../../components/Icon";
import ScrollToTop from "../../components/commons/ScrollToTop";
import InfiniteLoader from "../../components/commons/InfiniteLoader/InfiniteLoader";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { returnInputFieldLength } from "../../utils/commonFunctions";
import { RootState } from "../../redux/rootReducers";
import { resetSession } from "../../redux/auth";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import {
  createHelpModuleListAction,
  getHelpModuleListAction,
  resetHelpModuleAddMessage,
  resetHelpModuleAddSuccess,
  resetHelpModuleEditMessage,
  resetHelpModuleEditSuccess,
  resetHelpModuleError,
  resetHelpModuleFetching,
  resetHelpModuleListTotal,
  resetHelpModuleListing,
  resetHelpModuleMessage,
  resetHelpModuleStatusCode,
  resetHelpModuleSuccess,
  updateHelpModuleAction,
} from "../../redux/helpModule";
import { HELP_MODULE_HEADERS } from "../../constant/tableHeadersConstants/helpModuleConstants/helpModuleListConst";
import HelpModuleTable from "../../components/HelpModule/HelpModuleTable";

import { SingleUploadImageDataType } from "../../commonTypes/fileManagerTypes";
import { HelpPreview } from "../../components/HelpModule/HelpModulePreview";
import HelpModuleImagePreview from "../../components/HelpModule/HelpModuleImagePreview";
import {
  CreateHelpModulePayloadType,
  GetHelpModulePayloadType,
  UpdateHelpModulePayloadType,
} from "../../commonTypes/helpModuleTypes";
import { UploadFileIcon } from "../../assets/images";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { StockUploadFilePayloadType } from "../../commonTypes/clientSettingsTypes";
import {
  multipleUploadFilesAction,
  resetMultipleFileUploadData,
  resetMultipleFileUploadError,
  resetMultipleFileUploadFetching,
  resetMultipleFileUploadSuccess,
} from "../../redux/clientSettings";
import { MulitpleFileUploadData } from "../../redux/clientSettings/clientSettingTypes";
import { GetGenerateSasTokenPayloadType } from "../../commonTypes/stcoToolsType";
import {
  getTokenGenerateForDownloadAction,
  resetSasTokenForDownloadFile,
} from "../../redux/stcoTools";
import SinglePreviewWithApi from "../../components/commons/Upload/SinglePreviewWithApi";

interface FileObject {
  file: File;
  file_name: string;
  id: string;
}

type AppProps = {
  history: any;
  masterDataActivivtyCodeListing: [];
  fetching: boolean;
  message: string;
  addMessage: string;
  editMessage: string;
  editSuccess: null | number;
  addSuccess: null | number;
  success: null | number;
  token: null | string;
  error: null | string;
  statusCode: null | number;
  isOpen: boolean;
  helpModuleListing: any[];
  totalCount: number;
  sasTokenForDownloadFile: string;
  fileUploadData: MulitpleFileUploadData[] | [];
  dispatchAddHelpDetailsAction: (data: CreateHelpModulePayloadType) => void;
  dispatchGetHelpModuleListAction: (data: GetHelpModulePayloadType) => void;
  dispatchUpdateHelpModuleListAction: (
    data: UpdateHelpModulePayloadType
  ) => void;
  dispatchResetHelpModuleListing: () => void;
  dispatchResetHelpModuleListTotal: () => void;
  dispatchResetHelpModuleError: () => void;
  dispatchResetHelpModuleMessage: () => void;
  dispatchResetHelpModuleAddMessage: () => void;
  dispatchResetHelpModuleEditMessage: () => void;
  dispatchResetHelpModuleSuccess: () => void;
  dispatchResetHelpModuleFetching: () => void;
  dispatchResetSession: () => void;
  dispatchResetHelpModuleStatusCode: () => void;
  dispatchResetAddHelpModuleSuccess: () => void;
  dispatchResetHelpModuleEditSuccess: () => void;
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) => void;
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
  dispatchResetFileUploadFetching: () => void;
  dispatchResetFileUploadData: () => void;
  dispatchResetFileUploadSuccess: () => void;
  dispatchResetFileUploadError: () => void;
  dispatchResetSasTokenForDownloadFile: () => void;
};
const HelpModule = ({
  fetching,
  message,
  success,
  addMessage,
  editMessage,
  error,
  addSuccess,
  editSuccess,
  token,
  statusCode,
  totalCount,
  helpModuleListing,
  sasTokenForDownloadFile,
  fileUploadData,
  dispatchGetHelpModuleListAction,
  dispatchAddHelpDetailsAction,
  dispatchResetHelpModuleListing,
  dispatchResetHelpModuleListTotal,
  dispatchResetHelpModuleError,
  dispatchResetSession,
  dispatchUpdateHelpModuleListAction,
  dispatchResetHelpModuleMessage,
  dispatchResetHelpModuleSuccess,
  dispatchResetHelpModuleAddMessage,
  dispatchResetHelpModuleEditMessage,
  dispatchResetHelpModuleFetching,
  dispatchResetHelpModuleStatusCode,
  dispatchResetHelpModuleEditSuccess,
  dispatchResetAddHelpModuleSuccess,
  dispatchUploadFilesAction,
  dispatchGetTokenGenerateForDownloadAction,
  dispatchResetFileUploadFetching,
  dispatchResetFileUploadData,
  dispatchResetFileUploadSuccess,
  dispatchResetFileUploadError,
  dispatchResetSasTokenForDownloadFile,
}: AppProps) => {
  const [showAddHelpDetailModal, setShowHelpDetailModal] =
    useState<boolean>(false);
  const [id, setId] = useState<string | null | undefined>(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [searchData, setSearchData] = useState("");
  const [data, setData] = useState<[] | any[]>([]);
  const [editData, setEditData] = useState<any>({});
  const [description, setDescription] = useState<string>("");
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [addLinkText, setAddLinkText] = useState<string>("");
  const [addLinkError, setAddLinkError] = useState<string>("");
  const [titleError, setTitleError] = useState<string>("");
  const [helpTitle, setHelpTitle] = useState<string>("");
  // const [files, setFiles] = useState<any>([]);
  const [files, setFiles] = useState<FileObject[]>([]);
  const [editFiles, setEditFiles] = useState<any>([]);
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [previewData, setPreviewData] = useState<SingleUploadImageDataType>({
    fileUrl: "",
    fileType: "",
    finalFileName: "",
  });
  const [imageDetails, setImageDetails] = useState<SingleUploadImageDataType>({
    fileUrl: "",
    fileType: "",
    finalFileName: "",
  });
  const [previewUrl, setPreviewUrl] = useState<any>(null);
  //====================User Management=============================
  const [isAddHelpDetailsPresent, setIsAddHelpDetailsPresent] = useMenuCheck();
  const [isEditHelpDetailsPresent, setIsEditHelpDetailsPresent] =
    useMenuCheck();
  const [isGetHelpDetailsPresent, setIsGetHelpDetailsPresent] = useMenuCheck();
  //=================================================================
  useEffect(() => {
    dispatchResetFileUploadFetching();
    dispatchResetFileUploadData();
    dispatchResetFileUploadSuccess();
    dispatchResetFileUploadError();
    dispatchResetSasTokenForDownloadFile();
    dispatchResetHelpModuleSuccess();
    dispatchResetHelpModuleMessage();
    dispatchResetHelpModuleAddMessage();
    dispatchResetHelpModuleEditMessage();
    dispatchResetHelpModuleError();
    dispatchResetHelpModuleListing();
    dispatchResetHelpModuleListTotal();
    dispatchResetHelpModuleStatusCode();
    dispatchResetAddHelpModuleSuccess();
    dispatchResetHelpModuleEditSuccess();
    setIsAddHelpDetailsPresent("Add Help Module", "menu");
    setIsEditHelpDetailsPresent("Edit Help Module", "menu");
    setIsGetHelpDetailsPresent("Get Help Module Listing", "menu");

    if (!isEdit) {
      setHelpTitle("");
      setDescription("");
      setFiles([]);
      setAddLinkText("");
    }
  }, []);
  useEffect(() => {
    if (isEdit) {
      setShowHelpDetailModal(true);
      setHelpTitle(editData?.title);
      setDescription(editData?.description);
      setFiles(editData?.attachments);
      setAddLinkText(editData?.video_link);
      setIsEdit(true);
      setId(editData?._id);
      if (editData?.attachments[0]) {
        setEditFiles(editData?.attachments);
        let data: any = {
          file_name: editData?.attachments[0]?.file_name,
          file_url: editData?.attachments[0]?.file_url,
          file_type: editData?.attachments[0]?.file_type,
        };
        getImageDetails(data);
      }
    } else {
      setHelpTitle("");
      setDescription("");
      setAddLinkText("");
      setPreviewUrl("");
      setImageDetails({
        fileUrl: "",
        fileType: "",
        finalFileName: "",
      });

      setFiles(() => []);
    }
  }, [isEdit]);

  useEffect(() => {
    if (fileUploadData?.[0]?.file_url) {
      setImageDetails({
        fileUrl: fileUploadData?.[0]?.file_url,
        fileType: fileUploadData?.[0]?.file_type,
        finalFileName: fileUploadData?.[0]?.file_name,
      });
    }
  }, [fileUploadData]);
  useEffect(() => {
    if (helpModuleListing?.length === 0) {
      setData(helpModuleListing);
    } else if (
      offset > 0 &&
      helpModuleListing?.length > 0 &&
      !fetching &&
      (editMessage !== "Help details has been updated  successfully!" ||
        addMessage == "Help details has been added successfully!")
    ) {
      setData((prv: any) => [...prv, ...helpModuleListing]);
    } else {
      setData(helpModuleListing);
    }
  }, [helpModuleListing]);

  const handleHelpTitleChange = (e: any) => {
    setHelpTitle(e.target.value);
    if (titleError) {
      setTitleError("");
    }
  };

  useEffect(() => {
    // dispatchResetHelpModuleListing();
    if (token) {
      let finalData = {
        token,
        limit,
        offset,
        search_term: searchData,
      };
      if (totalCount) {
        if (offset < +totalCount) {
          dispatchGetHelpModuleListAction(finalData);
        }
      } else {
        dispatchGetHelpModuleListAction(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData) {
        fetchNewData();
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchData]);

  useEffect(() => {
    if (!showAddHelpDetailModal) {
      setIsEdit(false);
    }
  }, [showAddHelpDetailModal]);

  const fetchNewData = () => {
    if (token) {
      let finalData = {
        token,
        search_term: searchData,
        limit,
        offset,
      };
      if (offset === 0) {
        // setOffset(0)
        dispatchGetHelpModuleListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleSearch = (e: any) => {
    // dispatchResetHelpModuleListing()
    let value = e.target.value;
    setSearchData(value);
    if (value?.length === 0) {
      let finalData = {
        offset: 0,
        limit,
        token,
      };
      dispatchGetHelpModuleListAction(finalData);
    }
  };

  const toggleAddHelpDetailsModal = () => {
    setHelpTitle("");
    setDescription("");
    setAddLinkText("");
    setImageDetails({
      fileType: "",
      fileUrl: "",
      finalFileName: "",
    });
    setPreviewUrl("");

    setFiles(() => []);
    if (!showAddHelpDetailModal) {
      // handleResetData();
    }
    setShowHelpDetailModal(!showAddHelpDetailModal);
  };

  const handleDescriptionChange = (e: any) => {
    setDescription(e.target.value);
    if (titleError) {
      setTitleError("");
    }
  };
  const handleAddLinkTextChange = (e: any) => {
    setAddLinkText(e.target.value);

    if (addLinkError) {
      setAddLinkError("");
    }
  };

  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "created-help-module":
        return setSuccessMessage("Help details has been added successfully!");
      case "update-help-module":
        return setSuccessMessage(
          "Help details has been updated  successfully!"
        );
      default:
        return setSuccessMessage("");
    }
  };
  const uploadFiles = async (uploadedFile: any) => {
    const file = uploadedFile?.target?.files[0];
    const finalData = {
      token,
      fileData: file,
      containerType: 4,
    };
    return dispatchUploadFilesAction(finalData);
  };
  //
  useEffect(() => {
    if (
      imageDetails?.fileUrl?.length > 0 ||
      fileUploadData[0]?.file_url?.length > 0
    ) {
      setPreviewUrl("");

      let finalData = {
        token,
        fileUrl: isEdit ? imageDetails?.fileUrl : fileUploadData[0]?.file_url,
        containerType: 4,
      };
      dispatchGetTokenGenerateForDownloadAction(finalData);
    }
    dispatchResetSasTokenForDownloadFile();
  }, [fileUploadData, isEdit, imageDetails?.fileUrl]);

  useEffect(() => {
    if (sasTokenForDownloadFile) {
      setPreviewUrl(sasTokenForDownloadFile);
    }
  }, [sasTokenForDownloadFile]);

  const removeFile = () => {
    dispatchResetSasTokenForDownloadFile();
    setPreviewUrl("");
    setImageDetails({
      fileType: "",
      fileUrl: "",
      finalFileName: "",
    });
    setFiles(() => []);
    setEditFiles([]);
    // resetImageUrl();
    dispatchResetFileUploadData();
  };

  const handleAddHelpDetails = (e: any) => {
    setOffset(0);
    dispatchResetHelpModuleListing();
    dispatchResetHelpModuleError();
    dispatchResetHelpModuleSuccess();
    dispatchResetHelpModuleMessage();
    dispatchResetHelpModuleFetching();
    dispatchResetHelpModuleStatusCode();
    dispatchResetFileUploadData();
    dispatchResetSasTokenForDownloadFile();
    setEditFiles([]);
    toggleAddHelpDetailsModal();
    if (isEdit) {

      let updateData: UpdateHelpModulePayloadType = {
        title: helpTitle,
        description: description,
        attachments: fileUploadData.length > 0 ? fileUploadData : editFiles,
        video_link: addLinkText,
        token: token,
        _id: id,
      };

      dispatchUpdateHelpModuleListAction(updateData);
      handleSuccessMessage("update-help-module");
      setSearchData("");
    } else {
      let finalAddData: CreateHelpModulePayloadType = {
        title: helpTitle,
        description: description,
        attachments: fileUploadData,
        video_link: addLinkText,
        token: token,
      };
      dispatchAddHelpDetailsAction(finalAddData);
      handleSuccessMessage("created-help-module");
      setSearchData("");
    }
  };

  const handleEditHelpModule = (data: any) => {
    setOffset(0);
    setIsEdit(true);
    setEditData(data);
    getImageDetails(data);
    dispatchResetHelpModuleError();
    dispatchResetHelpModuleSuccess();
    dispatchResetHelpModuleMessage();
    dispatchResetHelpModuleFetching();
    dispatchResetHelpModuleStatusCode();
  };

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (
        offset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (helpModuleListing?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [helpModuleListing]);

  const getImageDetails = (data: any) => {
    setImageDetails({
      ...data,
      fileUrl: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };
  const handleEditFileList = (index: number) => {
    const tempFileData = JSON.parse(JSON.stringify(files));
    const isFilePresent = tempFileData?.find((data: any, idx: number) => {
      return idx === index;
    });

    if (!!isFilePresent) {
      let newData = tempFileData?.filter(
        (data: any, idx: number) => idx !== index
      );
      setFiles(newData);
    }
  };
  const resetImageUrl = () => {
    setImageDetails({
      fileUrl: "",
      fileType: "",
      finalFileName: "",
    });
  };
  const handleOpenPreview = (data: any) => {
    setPreviewData({
      ...previewData,
      fileUrl: data?.attachments?.[0]?.file_url,
      fileType: data?.attachments?.[0]?.file_type,
      finalFileName: data?.attachments?.[0]?.file_name,
    });
    setShowImagePreview(!showImagePreview);
  };

  const handleErrorModal = () => {
    if (success === 0 || editSuccess === 0 || addSuccess === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetHelpModuleError();
            }}
          />
        );
      }
    }

    if (addSuccess === 1 || editSuccess === 1) {
      if (
        addSuccess === 1 &&
        addMessage == "Help details has been added successfully!"
      ) {
        dispatchResetHelpModuleAddMessage();
        dispatchResetHelpModuleEditMessage();
        dispatchResetHelpModuleEditSuccess();
        dispatchResetHelpModuleMessage();
        toast.success(successMessage, {
          duration: 2000,
        });

        if (token) {
          dispatchResetHelpModuleListing();
          if (offset === 0) {
            // setOffset(0)
            let finalData = { token, offset: 0, limit };
            dispatchGetHelpModuleListAction(finalData);
          } else {
            setOffset(0);
            let finalData = { token, offset: 0, limit };
            // dispatchGetHelpModuleListAction(finalData);
          }
        }
      } else if (
        editSuccess === 1 &&
        editMessage == "Help details has been updated  successfully!"
      ) {
        dispatchResetHelpModuleAddMessage();
        dispatchResetHelpModuleEditMessage();
        dispatchResetAddHelpModuleSuccess();
        dispatchResetHelpModuleMessage();
        toast.success(successMessage, {
          duration: 2000,
        });
        if (token) {
          // dispatchResetHelpModuleListing()
          if (offset === 0) {
            // setOffset(0)
            let finalData = { token, offset, limit };
            dispatchGetHelpModuleListAction(finalData);
          } else {
            // dispatchResetHelpModuleListing()
            setOffset(0);
          }
        }
      }
    }

    return false;
  };

  const handlePreviewImageModal = () => {
    setShowImagePreview(!showImagePreview);
    dispatchResetSasTokenForDownloadFile();
  };

  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader title="Help Module" />
      </div>
      {isGetHelpDetailsPresent && (
        <div className="col-md-12">
          <div className="jobs-card">
            <div className="header">
              <div className="left-header">
                <div className="heading"> Help Details List</div>
                <div className="sub-heading">{`Total ${
                  totalCount ? totalCount : 0
                } entries found`}</div>
              </div>
              <div className="right-header">
                <div
                  className={`${
                    isAddHelpDetailsPresent ? "col-md-5" : "col-md-10"
                  } position-relative`}
                >
                  <span
                    style={{ position: "absolute", top: "8px", left: "25px" }}
                  >
                    <SearchIcon />
                  </span>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search"
                    onChange={(e: any) => handleSearch(e)}
                    style={{ paddingLeft: "35px" }}
                    value={searchData}
                  />
                </div>
                {isAddHelpDetailsPresent && (
                  <button
                    onClick={toggleAddHelpDetailsModal}
                    className="btn btn-primary"
                  >
                    + Add Help Details
                  </button>
                )}
              </div>
            </div>

            <div>
              {fetching && offset == 0 ? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : helpModuleListing?.length > 0 ? (
                <div className="jobsType">
                  <table className="table thead-light table-bordered">
                    <thead className="text-start sticky-table-header">
                      {isEditHelpDetailsPresent ? (
                        <TableHeader
                          tableHeader={HELP_MODULE_HEADERS}
                          extraHeader
                        />
                      ) : (
                        <TableHeader tableHeader={HELP_MODULE_HEADERS} />
                      )}
                    </thead>
                    <tbody>
                      <HelpModuleTable
                        // data={helpModuleListing}
                        data={data}
                        tableHeaders={HELP_MODULE_HEADERS}
                        handleOpenPreview={handleOpenPreview}
                        isEditHelpDetailsPresent={isEditHelpDetailsPresent}
                        handleEditHelpModule={handleEditHelpModule}
                      />
                      <div style={{ display: fetching ? "none" : "inline" }}>
                        <ScrollToTop />
                      </div>
                      {fetching && offset > 0 && (
                        <div>{<InfiniteLoader />}</div>
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                <>
                  {fetching === false && helpModuleListing?.length === 0 && (
                    <EmptyListPage title="No Help Details !" imageWidth="30%" />
                  )}
                </>
              )}
            </div>
            {/* <Toaster /> */}
          </div>
        </div>
      )}
      {showAddHelpDetailModal ? (
        <Modal
          centered
          isOpen={showAddHelpDetailModal}
          toggle={toggleAddHelpDetailsModal}
          size="xl"
          backdrop="static"
        >
          <ModalHeader
            className="pt-4 pl-4"
            id="cross-cut"
            toggle={toggleAddHelpDetailsModal}
          >
            {`${isEdit ? "Edit" : "Add"} Help Details`}
          </ModalHeader>
          <ModalBody className="pl-4 pr-4" style={{ paddingLeft: "40px" }}>
            <>
              <div
                className="d-flex w-100"
                style={{ justifyContent: "space-between" }}
              >
                <div style={{ width: "50%", marginRight: "20px" }}>
                  <form>
                    <div>
                      <label htmlFor="Acitivity code">
                        Help Title <span className="color-red">*</span>
                      </label>
                      <div className="d-flex flex-row position-relative">
                        <input
                          type="text"
                          className={`form-control ${
                            !!titleError ? "error-border" : null
                          }`}
                          name="text"
                          value={helpTitle}
                          autoFocus
                          onChange={(e) => handleHelpTitleChange(e)}
                          maxLength={60}
                          // onKeyPress={(e: any) =>
                          //   e.key === "Enter" ?null:handleAddHelpDetails(e)
                          // }
                        />
                      </div>

                      {!!titleError && helpTitle?.length === 0 && (
                        <small className="text-danger">{titleError}</small>
                      )}
                    </div>
                    <span className="input-length">
                      {returnInputFieldLength(helpTitle?.length, 60)}
                    </span>
                    {/* </div> */}
                    <div className="mt-2">
                      <label htmlFor="status">Description</label>
                      <textarea
                        style={{ width: "100%" }}
                        className={`form-control ${
                          !!titleError ? "error-border" : null
                        }`}
                        name="text"
                        value={description}
                        autoFocus
                        onChange={(e) => handleDescriptionChange(e)}
                        maxLength={300}
                        // onKeyPress={(e: any) =>
                        //   e.key === "Enter" ? lank():handleAddHelpDetails(e)
                        // }
                      />
                      {/* {returnInputFieldLength(description?.length, 300)&& (
                        <small className="text-danger">Max Length 300 Character</small>
                      )} */}
                      <span className="input-length">
                        {returnInputFieldLength(description?.length, 300)}
                      </span>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="commentBox"
                        className={addLinkText ? "active" : ""}
                        style={{ color: "#262a44" }}
                      >
                        Add Video Link
                      </label>
                      <input
                        type="text"
                        placeholder="Add Video URL Link Here"
                        className={`form-control ${
                          !!addLinkError ? "error-border" : null
                        }`}
                        value={addLinkText}
                        autoFocus
                        onChange={(e) => handleAddLinkTextChange(e)}
                        // onKeyPress={(e: any) =>
                        //   e.key === "Enter" ?   null:handleSubmitDocumentLink(e)
                        // }
                      />
                    </div>
                    {files?.length > 0 && (
                      <div className="mt-3">
                        {files?.map((data: any, index: number) => {
                          let file_type = data.file_url.split(".");
                          {
                          }
                          return file_type[
                            file_type.length - 1
                          ].toLowerCase() === "png" ||
                            file_type[file_type.length - 1].toLowerCase() ===
                              "jpg" ||
                            file_type[file_type.length - 1].toLowerCase() ===
                              "jpeg" ||
                            file_type[file_type.length - 1].toLowerCase() ===
                              "doc" ||
                            file_type[file_type.length - 1].toLowerCase() ===
                              "docx" ||
                            file_type[file_type.length - 1].toLowerCase() ===
                              "xls" ||
                            file_type[file_type.length - 1].toLowerCase() ===
                              "ppt" ||
                            file_type[file_type.length - 1].toLowerCase() ===
                              "pptx" ||
                            file_type[file_type.length - 1].toLowerCase() ===
                              "xlsx" ||
                            file_type[file_type.length - 1].toLowerCase() ===
                              "pdf"
                            ? HelpPreview(
                                data,
                                index,
                                getImageDetails,
                                handleEditFileList
                              )
                            : null;
                        })}
                      </div>
                    )}
                  </form>

                  <div
                    style={{
                      display: "flex",
                      float: "right",
                      marginTop: "4rem",
                    }}
                  >
                    <button
                      className="pointer mr-3 pr-4 pl-4"
                      onClick={toggleAddHelpDetailsModal}
                      style={{
                        border: "2px solid rgb(191, 203, 225)",
                        color: "#dd4433",
                        fontSize: "14px",
                        borderRadius: "4px",
                        background: "#ffffff",
                      }}
                    >
                      Cancel
                    </button>
                    <Button
                      color="primary ml-3"
                      style={{ padding: "6px 25px", fontSize: "14px" }}
                      disabled={!helpTitle.trim()}
                      onClick={(e: any) => {
                        handleAddHelpDetails(e);
                      }}
                    >
                      {isEdit ? "Update" : "Save"}
                    </Button>
                  </div>
                </div>

                <div className="ml-2" style={{ width: "50%" }}>
                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                      color: "#262a44",
                    }}
                  >
                    Upload help file
                  </span>
                  <div className="mt-3 p-0">
                    {previewUrl?.length == 0 && (
                      <div
                        className="dropzone drop-area-white text-center"
                        style={{
                          cursor: "pointer",
                          border: "1px dashed #bfcbe1",
                          borderRadius: "8px",
                          width: "100%",
                          height: "50vh",
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <img
                          src={UploadFileIcon}
                          alt="upload"
                          className="mb-4"
                        />
                        <h4 className="text-center">
                          <span
                            style={{
                              textDecoration: "underline",
                              color: "#dd4433",
                            }}
                          >
                            <label
                              htmlFor="file-upload"
                              style={{
                                color: "#dd4433",
                                textDecoration: "underline",
                                paddingRight: "4px",
                                cursor: "pointer",
                              }}
                            >
                              Choose File
                            </label>
                            <input
                              type="file"
                              id="file-upload"
                              accept="image/png, image/gif, application/pdf , image/jpeg, application/vnd.ms-excel, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
                              multiple
                              onChange={uploadFiles}
                              style={{ display: "none" }}
                            />
                          </span>
                          to upload
                        </h4>
                        <p className="text-center text-muted ">
                          Supported formats are PNG, JPEG, PDF,
                          <br /> Excel, PPT, PPTX and Doc
                        </p>
                      </div>
                    )}
                  </div>
                  {/* </div> */}

                  {fetching && <Loader />}
                  {previewUrl?.length != 0 && (
                    <HelpModuleImagePreview
                      removeFile={removeFile}
                      resetImageUrl={resetImageUrl}
                      previewUrl={previewUrl}
                      imageDetails={imageDetails}
                    />
                  )}
                </div>
              </div>
            </>
          </ModalBody>
        </Modal>
      ) : (
        ""
      )}

      {showImagePreview && (
        <SinglePreviewWithApi
          resetImageUrl={handlePreviewImageModal}
          imageDetails={previewData}
          token={token}
        />
      )}
      {handleErrorModal()}
      <Toaster />
      {/* {fetching && offset === 0 && <Loader />} */}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.helpModule.fetching,
  statusCode: state.helpModule.statusCode,
  error: state.helpModule.error,
  success: state.helpModule.success,
  message: state.helpModule.message,
  addMessage: state.helpModule.addMessage,
  editMessage: state.helpModule.editMessage,
  helpModuleListing: state.helpModule.helpModuleList,
  totalCount: state.helpModule.helpModuleTotalCount,
  editSuccess: state.helpModule.editSuccess,
  addSuccess: state.helpModule.addSuccess,
  fileUploadData: state.clientSettings.multipleFileUploadData,
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetHelpModuleError: () => dispatch(resetHelpModuleError()),
  dispatchResetHelpModuleMessage: () => dispatch(resetHelpModuleMessage()),
  dispatchResetHelpModuleAddMessage: () =>
    dispatch(resetHelpModuleAddMessage()),
  dispatchResetHelpModuleEditMessage: () =>
    dispatch(resetHelpModuleEditMessage()),

  dispatchResetAddHelpModuleSuccess: () =>
    dispatch(resetHelpModuleAddSuccess()),
  dispatchResetHelpModuleEditSuccess: () =>
    dispatch(resetHelpModuleEditSuccess()),
  dispatchResetHelpModuleSuccess: () => dispatch(resetHelpModuleSuccess()),

  dispatchResetHelpModuleFetching: () => dispatch(resetHelpModuleFetching()),
  dispatchResetHelpModuleStatusCode: () =>
    dispatch(resetHelpModuleStatusCode()),

  dispatchResetHelpModuleListing: () => dispatch(resetHelpModuleListing()),
  dispatchResetHelpModuleListTotal: () => dispatch(resetHelpModuleListTotal()),

  dispatchAddHelpDetailsAction: (data: CreateHelpModulePayloadType) =>
    dispatch(createHelpModuleListAction(data)),

  dispatchGetHelpModuleListAction: (data: GetHelpModulePayloadType) =>
    dispatch(getHelpModuleListAction(data)),

  dispatchUpdateHelpModuleListAction: (data: UpdateHelpModulePayloadType) =>
    dispatch(updateHelpModuleAction(data)),

  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) =>
    dispatch(multipleUploadFilesAction(data)),

  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => dispatch(getTokenGenerateForDownloadAction(data)),

  dispatchResetFileUploadFetching: () =>
    dispatch(resetMultipleFileUploadFetching()),

  dispatchResetFileUploadData: () => dispatch(resetMultipleFileUploadData()),

  dispatchResetFileUploadSuccess: () =>
    dispatch(resetMultipleFileUploadSuccess()),

  dispatchResetFileUploadError: () => dispatch(resetMultipleFileUploadError()),

  dispatchResetSasTokenForDownloadFile: () =>
    dispatch(resetSasTokenForDownloadFile()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HelpModule);
